import React, { useState } from "react";
import { useI18n } from "../context/I18nContext";
import { useAuth, api } from "../context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { House, PiggyBank, Ticket, ShareNetwork, CaretRight } from "@phosphor-icons/react";

export const OnboardingModal = ({ onNavigate }) => {
  const { t } = useI18n();
  const { user, refreshUser } = useAuth();
  const [open, setOpen] = useState(() => user ? !user.onboarding_dismissed : false);
  const done = () => {
    setOpen(false);
    api.post("/me/onboarding-dismiss").then(() => refreshUser && refreshUser()).catch(() => {});
  };
  const go = (section) => { done(); if (onNavigate) onNavigate(section); };
  const steps = [
    { icon: House, label: t("onboarding_step_accounts"), section: "cuentas" },
    { icon: PiggyBank, label: t("onboarding_step_goal"), section: "cuentas" },
    { icon: Ticket, label: t("onboarding_step_raffle"), section: "boletos" },
    { icon: ShareNetwork, label: t("onboarding_step_referral"), section: "referidos" },
  ];
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) done(); }}>
      <DialogContent data-testid="onboarding-modal" className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-emerald-900 text-2xl">{t("onboarding_title")}</DialogTitle>
          <DialogDescription>{t("onboarding_sub")}</DialogDescription>
        </DialogHeader>
        <div className="space-y-2.5 mt-1">
          {steps.map((s, i) => (
            <button key={i} data-testid={`onboarding-step-${i}`} onClick={() => go(s.section)} className="w-full flex items-center gap-3 rounded-xl border border-emerald-100 bg-emerald-50/40 hover:bg-emerald-50 px-4 py-3 text-left transition-colors">
              <div className="h-9 w-9 rounded-lg bg-emerald-100 flex items-center justify-center shrink-0"><s.icon size={20} weight="duotone" className="text-emerald-800" /></div>
              <span className="flex-1 text-sm font-semibold text-emerald-900">{s.label}</span>
              <CaretRight size={16} weight="bold" className="text-emerald-400" />
            </button>
          ))}
        </div>
        <div className="flex items-center justify-between mt-4">
          <button data-testid="onboarding-skip" onClick={done} className="text-sm text-slate-400 hover:text-slate-600">{t("onboarding_skip")}</button>
          <Button data-testid="onboarding-done" onClick={done} className="bg-emerald-800 hover:bg-emerald-900">{t("onboarding_done")}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
